$(document).ready(function() {

	var links = document.links;
	for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

	
	// Desktop Nav
	$('.main-nav .has-secondary').mouseover(function(e){
		e.preventDefault();
		$('.main-nav__secondary').removeClass('open');
		$('.main-nav .has-secondary').removeClass('open');

		$(this).siblings('.main-nav__secondary').addClass('open');
		$(this).addClass('open');
	});

	$('body').mouseover(function(e){
		e.preventDefault();
		$('.main-nav__secondary').removeClass('open');
		$('.main-nav .has-secondary').removeClass('open');
	});



	$('.main-nav__secondary, .main-nav .has-secondary').mouseover(function(e) {
		e.stopPropagation();
	});

	// Add background colour to navigation on scroll
	$(window).scroll(function() {
		var scroll = $(window).scrollTop();

		if (scroll >= 400) {
			$('.header').addClass('with-background');
		} else {
			$('.header').removeClass('with-background');
		}
	});

	// Mobile Icon Toggle
	$('#mobile-toggle').click(function(e){
		e.preventDefault();

		if($(this).hasClass('open')) {
			$(this).removeClass('open');
			$('.mobile-nav').removeClass('open');
			$('body').removeClass('nav-open');

			$(".mobile-nav__nav li").each(function(index) {
				$(this).delay(50 * index).fadeTo("slow", 0);
			});
		} else {
			$(this).addClass('open');
			$('.mobile-nav').addClass('open');
			$('body').addClass('nav-open');

			setTimeout(function() {
				$(".mobile-nav__nav > li").each(function(index) {
					$(this).delay(100 * index).fadeTo("slow", 1);
				});
			}, 300);
		}
	});

	// Mobile Secondary Toggle

	$(".mobile-nav__nav .has-secondary").on("click", function(e) {
		e.preventDefault();

		if($(this).siblings('.mobile-nav__secondary').hasClass('open')) {
			$(this).siblings('.mobile-nav__secondary').removeClass('open');
			$(this).find('.icon-plus').removeClass('open');
		} else {
			$(this).siblings('.mobile-nav__secondary').addClass('open');
			$(this).find('.icon-plus').addClass('open');
		}

		return false;

	});

	// Show promo bar on scroll
	var lastScrollTop = 0;

	$(window).scroll(function() {
		var scroll = $(window).scrollTop();
		var st = $(this).scrollTop();

		if (st > lastScrollTop){
			$('.promo-bar').removeClass('active');
		} else {
			$('.promo-bar').addClass('active');
		}
		lastScrollTop = st;

		if (scroll >= 400) {
		} else {
		}
	});

	// Slideshow
	var $mainSlideshow = $('.slideshow');

	if($mainSlideshow.length) {
		$('.slideshow').on('init', function(event, slick){
			$this = $(this);

			setTimeout(function(){
				$this.find('.slideshow__content').addClass('shown');
			}, 1000);

		});

		$('.slideshow').on('beforeChange', function(event, slick){
			$(this).find('.slideshow__content').removeClass('shown');
		});

		$('.slideshow').on('afterChange', function(event, slick){
			$(this).find('.slideshow__content').addClass('shown');
		});

		$mainSlideshow.slick({
			speed: 1000,
			prevArrow: $('.prev-arrow'),
			nextArrow: $('.next-arrow'),
			waitForAnimate: false,
			autoplay: $mainSlideshow.data('autoplay'),
			autoplaySpeed: $mainSlideshow.data('speed'),
			pauseOnHover: false
		});
	} else {
		setTimeout(function(){
			$('.slideshow__content').addClass('shown');
		}, 1000);
	}

	$('.slideshow__arrow').click(function(e){
		var $pageHeight = $(this).parents('section').innerHeight();

		e.preventDefault();
		$("html, body").stop().animate({ scrollTop: $pageHeight }, 1000);
	});

	/* ----------------------------- Fixed Button ----------------------------- */

	if ($('body').hasClass("template-index")) {
		var s = $(".button-primary.button-fixed");
		var pos = s.position();
		var navHeight = $('.header').innerHeight();

		console.log(navHeight);

		$(window).scroll(function() {
			var windowpos = $(window).scrollTop();

			if (windowpos + navHeight >= pos.top) {
					s.addClass("fixed");
					s.css('top', navHeight);
			} else {
					s.removeClass("fixed");
					s.css('top', "auto");
			}
		});
	}

	/* ----------------------------- Nav Scrollto ----------------------------- */

	if ($('body').hasClass("template-index") || $('body').hasClass("template-all") || $('body').hasClass("template-usa") || $('body').hasClass("template-our-land") || $('body').hasClass("template-stockists")) {
		$('.nav-panel__scrollto').click(function(e){
			var section = $(this).attr('href');
			var navHeight = $('.header').innerHeight();

			e.preventDefault();
			$("html, body").stop().animate({scrollTop: $(section).offset().top - navHeight }, 800);
		});
	}

	/* ----------------------------- Ajax Add To Cart ----------------------------- */
	
	if ($('body').hasClass("template-all") || $('body').hasClass('template-wine-club') || $('body').hasClass('template-madre')) {
		$(".button-add-to-cart").on("click", function(e) {
			e.preventDefault();
			var button = $(this)

			$(button).text('   ').addClass('loading');

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: $(this).parents('form').serialize(),
				success: function() {
					$(button).html('This has successfully been added to your cart').removeClass('loading').addClass('success');

					jQuery.getJSON('/cart.js', function(cart) {
						$('.header__bag-count').text(cart.item_count);
					});

					setTimeout(function(){
						$(button).html('Add to Cart').removeClass('success');
					}, 3000);
				},
				error: function() {
					$(button).html('Please try again').removeClass('loading');

					setTimeout(function(){
						$(button).html('Add to Cart');
					}, 3000);
				}

			});
		});
	}


	/* --- Cart Page ----------------------------- */

	if ($('body').hasClass("template-cart")) {
		$('.checkout-btn').on('click',function(e){
			e.preventDefault();

			
			console.log("us products");
		});
		$(".cart-item__change").on("change", function() {
			var line_item = $(this).data('item');
			var quantity = $(this).val();
			var $linePrice = $(this).parents('tr').find('.cart-item__line-price');

			$.ajax({
				type:"POST",
				url: '/cart/change.js',
				dataType: 'json',
				data: { line: line_item, quantity: quantity },
				success: function(cart) {
					$('.cart__subtotal-price').text(Shopify.formatMoney(cart.total_price));
					$('.header__bag-count').text(cart.item_count);

					for(var i=0; i < cart.items.length; i++){
						var item = cart.items[i];
						var price_element = $('.line-total-' + item.id);
						price_element.html(Shopify.formatMoney(item.line_price));
					};
				}
			});
		});
		$('#checkout_button').click(function(e){
			if (!$('#purchasers_age').is(':checked')) {
				e.preventDefault();
				$('label[for="purchasers_age"]').addClass('error');
			}
		})
	}

	/* --- Accordion ----------------------------- */

	if ($('body').hasClass('template-product') || $('body').hasClass('template-all') || $('body').hasClass('template-usa') || $('body').hasClass('template-gifting-experiences') || $('body').hasClass('template-madre') || $('body').hasClass('template-usa-wine-club') || $('body').hasClass('template-wine-club') || $('body').hasClass('template-shipping-policy')) {

		$('.accordion__toggle').on("click", function() {
			if($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).siblings('.accordion__content').removeClass('active');
				$(this).find('.icon-plus').removeClass('open');
			} else {
				$(this).addClass('active');
				$(this).siblings('.accordion__content').addClass('active');
				$(this).find('.icon-plus').addClass('open');
			}
		});
	}

	/* --- Collection.all Page ----------------------------- */

	if ($('body').hasClass('template-all') || $('body').hasClass('template-usa') || $('body').hasClass('template-gifting-experiences') || $('body').hasClass('template-madre') || $('body').hasClass('template-wine-club'))  {

		$('.fake-checkbox').on("click", function() {

			var productVariants = $('#Includes').val().trim();
			var productVariantLabel = $(this).find('.checkbox-label').data('label');
			var productVariantsArray = productVariants.split(', ');

			if($(this).hasClass('clicked')) {

				if (productVariantsArray.length != 1) {
					$(this).removeClass('clicked');

					productVariantsArray.splice( $.inArray(productVariantLabel, productVariantsArray), 1 );
					$('#Includes').val(productVariantsArray.join(", "));
				} else {
					alert("At least one variant must be selected!");
				}

			} else {
				var found = jQuery.inArray(productVariantLabel, productVariantsArray);

				$(this).addClass('clicked');

				if (found >= 0) {
					productVariantsArray.splice(found, 1);
				} else {
					productVariantsArray.push(productVariantLabel);
				}

				$('#Includes').val(productVariantsArray.join(", "));
			}

		});
	}

	/* --- Product Page ----------------------------- */

	if ($('body').hasClass('template-product')) {

		$('.product-reviews__slider').slick({
			speed: 800,
			prevArrow: $('.prev-arrow'),
			nextArrow: $('.next-arrow'),
			waitForAnimate: false,
			autoplay: false,
			pauseOnHover: false
		});

		$('.product__images-slider').slick({
			speed: 800,
			prevArrow: $('.prev-arrow'),
			nextArrow: $('.next-arrow'),
			waitForAnimate: false,
			autoplay: false,
			pauseOnHover: false,
			adaptiveHeight: true
		});

		$("#AddToCart").on("click", function(e) {
			e.preventDefault();
			var button = $(this)

	

			if(!button.hasClass('vinoShipper_addToCartBtn')){
				$(button).text(' ').addClass('loading');
				$.ajax({
					type: 'POST',
					url: '/cart/add.js',
					dataType: 'json',
					data: $(this).parents('form').serialize(),
					success: function() {
						$(button).html('This has successfully been added to your cart').removeClass('loading').addClass('success');

						jQuery.getJSON('/cart.js', function(cart) {
							$('.header__bag-count').text(cart.item_count);
						});

						setTimeout(function(){
							$(button).html('Add to Cart').removeClass('success');
						}, 3000);
					},
					error: function() {
						$(button).html('Please try again').removeClass('loading');

						setTimeout(function(){
							$(button).html('Add to Cart');
						}, 3000);
					}

				});
			}else{
				// $(button).html('This has successfully been added to your cart').removeClass('loading').addClass('success');
				// setTimeout(function(){
				// 	$(button).html('Add to Cart').removeClass('success');
				// }, 3000);

			}
		});
	}

	/* --- Stockists ----------------------------- */

	if ($('body').hasClass('template-stockists')) {

		$('.stockists-sidebar__link').click(function(e){
			var section = $(this).attr('data-distributor-toggle');
			var navHeight = $('.header').innerHeight();

			e.preventDefault();
			$("html, body").stop().animate({scrollTop: $('#' + section).offset().top - navHeight}, 800);
		});
	}

	/* --- Login Page ----------------------------- */

	if ($('body').hasClass("template-customers-login")) {
		$('#ForgotPassword').click(function(e){
			e.preventDefault();

			$('#CustomerLoginForm').addClass('hidden');
			$('#RecoverPasswordForm').removeClass('hidden');
		});

		$('#HideRecoverPasswordLink').click(function(e){
			e.preventDefault();

			$('#CustomerLoginForm').removeClass('hidden');
			$('#RecoverPasswordForm').addClass('hidden');
		});
	}

	/* --- Addresses Page ----------------------------- */

	if ($('body').hasClass("template-customers-addresses")) {
		$('#AddressNewButton').click(function(e){
			e.preventDefault();
			var $this = $(this);

			if($this.hasClass('active')) {
				$this.html('Add a New Address').removeClass('active');
				$('#AddressNewForm').removeClass('shown');
			} else {
				$this.html('Cancel').addClass('active');
				$('#AddressNewForm').addClass('shown');
			}
		});

		$('.button-edit-address').click(function(e){
			e.preventDefault();
			var $this = $(this);
			var $form = $this.parents('.account-address__address').find('.account-address__edit');

			if($this.hasClass('active')) {
				$this.html('Edit').removeClass('active');
				$form.removeClass('shown');
			} else {
				$this.html('Cancel').addClass('active');
				$form.addClass('shown');
			}
		});

		$('.customer-address__close').click(function(e){
			e.preventDefault();
			var $this = $(this);
			var $form = $this.parents('.account-address__address').find('.account-address__edit');
			var $button = $this.parents('.account-address__address').find('.button-edit-address');

			$button.html('Edit').removeClass('active');
			$form.removeClass('shown');
		});
	}

	/* --- Resources Page ----------------------------- */

	if ($('body').hasClass("template-resources")) {
		$('.gallery').magnificPopup({
			delegate: '.gallery__item', // child items selector, by clicking on it popup will open
			type: 'image',
			gallery: {
				enabled: true
			}
		});
	}

	/* --- Account Page ----------------------------- */

	if ($('body').hasClass("template-customers-account")) {
		$('.wine-club-nav ul li a').click(function(e){
			e.preventDefault();

			var section = $(this).text().toLowerCase().replace(' ', '-');
			console.log(section);

			$('.wine-club-nav ul li a').removeClass('active');
			$(this).addClass('active')

			$(".account__tab").addClass('hidden');
			$("#shopify-section-account__" + section).removeClass('hidden');
		});
	}
});
